/** Dominios de email mal escritos que suelen confundirse con Gmail u Hotmail. */
const COMMON_EMAIL_DOMAIN_MISTAKES: Record<string, string> = {
  'gmai.com': 'gmail.com',
  'gmial.com': 'gmail.com',
  'gmaill.com': 'gmail.com',
  'gmil.com': 'gmail.com',
  'gmsil.com': 'gmail.com',
  'gnail.com': 'gmail.com',
  'hormail.com': 'hotmail.com',
  'hotmial.com': 'hotmail.com',
  'hotmil.com': 'hotmail.com',
  'hotmai.com': 'hotmail.com',
  'homail.com': 'hotmail.com'
}

const INVALID_EMAIL_DOMAIN_EXTENSIONS = ['.con', '.cpm', '.comm', '.vom'] as const

/** Valida el dominio del email (typos comunes y extensiones incorrectas). */
export function validateEmailDomain(email: string): boolean {
  const domain = email.split('@')[1]?.toLowerCase()
  if (!domain) return true

  if (COMMON_EMAIL_DOMAIN_MISTAKES[domain]) {
    return false
  }

  if (INVALID_EMAIL_DOMAIN_EXTENSIONS.some(ext => domain.endsWith(ext))) {
    return false
  }

  return true
}
